import { createSelector } from 'reselect'

export const tideRatesSelector = state => state.tideRates

export const getSingleTideDataSelector = tideRateStationUuid =>
  createSelector(
    tideRatesSelector,
    tideRates => tideRates[tideRateStationUuid]
  )
